import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="notfound">
            <h1>404</h1>
            <h2>Page not found!</h2>
        </div>
    );
};

export default NotFound;